// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1E8zh","alert":"SettungsInbox_alert__3IRgW"};